export default "__VITE_ASSET__CGsUgVua__"